import { useToken } from "@/stores/authStore";
import { useGet, usePut } from "../useApi";
import { useMutation } from "@tanstack/react-query";
import { fetchClient } from "../fetchClient";
import { toastError } from "@/lib/Toast";

export function geUserInfo(options = {}) {
  const token = useToken();
  return useGet("user-info", `auth/user-info`, {}, {
    enabled: !!token,
    ...options,
  });
}

export function refreshToken() {
  return useMutation({
    mutationFn: (params = {}) =>
      fetchClient("auth/refresh-token", {
        method: "PUT",
        params,
        body: {},
      }),
  });
}
// ======= get all companies


export function getAllCompanies(companyId) {
  const token = useToken();

  return useGet(
    "all-companies",
    `companies/${companyId}/company-users?key=companies`,
    {},
    {
      enabled: !!token && !!companyId,
    },
  );
}

// ======= get all branches

export function getAllBranches(companyId){
  return useGet('all-branches',`companies/${companyId}/search?resource=branches`)

}
